// src/components/study/FocusTimer.tsx
// =====================================================================
// FOCUS TIMER - IDENTIDADE GRAIA
// Timer fixo no header para modo foco (20 minutos)
// =====================================================================

import React from 'react';
import './FocusTimer.css';

interface FocusTimerProps {
    timeRemaining: number; // segundos
    isComplete: boolean;
    onAddTime?: () => void;
}

const FocusTimer: React.FC<FocusTimerProps> = ({ timeRemaining, isComplete, onAddTime }) => {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    return (
        <div className={`focus-timer-header ${isComplete ? 'complete' : ''}`}>
            <div className="timer-label">
                {isComplete ? 'Sessão Concluída' : 'Modo Foco'}
            </div>
            <div className="timer-display">
                <span className="timer-icon">{isComplete ? '✓' : '⏱'}</span>
                <span className="timer-time">{formattedTime}</span>
                {isComplete && onAddTime && (
                    <button className="timer-add-btn" onClick={onAddTime} title="+10 minutos">
                        +10
                    </button>
                )}
            </div>
        </div>
    );
};

export default FocusTimer;